export const getFpId = (): number | null => {
  const fpId = sessionStorage.getItem('fpId')
  return fpId ? Number(fpId) : null
}

export const getSourceFpId = (): number | null => {
  const sourceFpId = sessionStorage.getItem('sourceFpId')
  return sourceFpId ? Number(sourceFpId) : null
}

export const isForceDisableLogo = (): boolean => {
  const forceDisableLogo = sessionStorage.getItem('forceDisableLogo')
  return forceDisableLogo === 'true'
}
